
if ( typeof autocloseTimer == "undefined" ) {
    var autocloseTimer;
}
$(document).on('click', 'a.language_selector', function(){

    let _token = $('meta[name="csrf-token"]').attr('content') || $('input[type="hidden"][name="_token"]').val();
    let lang = $(this).attr('data-language');
    let currentPage = window.location.pathname;
    let newPageUrl =$(this).attr('data-url');
    let modalSpinner = $('.modal-spinner');

    if( _token && lang){
        if ( modalSpinner) {
            modalSpinner.toggleClass('d-none');
        }
        if(autocloseTimer) {
            clearInterval(autocloseTimer);
        }
        $.post('/change_language',{ lang: lang, _token : _token, currentPage : currentPage })
            .done(function( data ) {

                if(data && data.status == "success")
                {
                    if ( data.isAdmin ) {
                        window.location.reload(true);
                    } else {
                        window.location.href = newPageUrl;
                    }
                }
            });
    }

});


$(document).on('hidden.bs.modal', '#uploadArticlesModal, #uploadVideosModal, #uploadAdsModal, #uploadMediaManager', function (e) {
    vm.$refs.custom_manager.resetManager();
    vm.$refs.custom_manager.$refs['clear-dropzone'].click();
    vm.$children[0].closeAll();
});

(function () {

    if (window.location.href.indexOf("administrator") > -1) {
        let showMenu = document.querySelector('.lang-switcher');
        let langMenu = document.querySelector('.lang-menu');
        let layer = document.querySelector('.layer');

        if (showMenu) {
            showMenu.addEventListener('click', function () {
                langMenu.classList.toggle('active');
            });

            return false;

            if (layer) {
                layer.addEventListener('click', function (e) {
                    if (langMenu.classList.contains('active')) {
                        langMenu.classList.remove('active');
                        layer.classList.remove('active');
                    }
                });
            }
        }
    }
})();

window.getRoute = async function (routeName = '', params = '') {

    let _token = document.querySelector('meta[name="csrf-token"]').getAttribute('content');
    const result = await axios.post('/getRoute', {_token, routeName, params});
    if ( result.status == 200 && (result.data.length > 0) ) {
        return result.data;
    }
    return '';

}


